import { LoruleRequestConfig } from '@galaxy/lorule-react-commons';
import { callWebUtils, commonHeaders } from './commonApiUtil';
import { OrganizationType, ProjectOrganizationType } from './amOrganizationApiTypes';

export const getUserProjectOrganizations = async (config: LoruleRequestConfig) =>
    callWebUtils<Array<ProjectOrganizationType>>(
        config,
        '/organization/project?filtered=true',
        'GET',
        null,
        commonHeaders,
    );

export const getProjectOrganizations = async (config: LoruleRequestConfig, name?: string) =>
    callWebUtils<Array<ProjectOrganizationType>>(
        config,
        `/organization/project${name ? `?name=${encodeURIComponent(name)}` : ''}`,
        'GET',
        null,
        commonHeaders,
    );

export const getOrganizations = async (config: LoruleRequestConfig, name?: string) =>
    callWebUtils<Array<OrganizationType>>(
        config,
        `/organization${name ? `?name=${encodeURIComponent(name)}` : ''}`,
        'GET',
        null,
        commonHeaders,
    );
